var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"p-3 mb-5"},[(_vm.info)?_c('b-row',[(_vm.info.pics)?_c('b-col',{staticClass:"text-center"},[_c('img',{staticClass:"image",attrs:{"src":_vm.img_path+_vm.image}})]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }